import { getDefaultApi } from './ChinookApiService';

export const getUtilisateur = (uidUtilisateur) => {
  return getDefaultApi()
    .getUtilisateur(uidUtilisateur)
    .then((response) => response.data);
};

export const mettreAjourIdentiteDirigeant = (uidUtilisateur, { valuesAenvoye }) => {
  return getDefaultApi()
    .updateInformationsUtilisateur(uidUtilisateur, valuesAenvoye)
    .then((response) => response.data);
};

export const mettreAjourFonctionDirigeant = (uidUtilisateur, { valuesAenvoye }) => {
  return getDefaultApi()
    .updateFonctionDansEntreprise(uidUtilisateur, valuesAenvoye)
    .then((response) => response.data);
};
